var _style, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRegisterPageAbstractShapes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000067222147271972704590000010949718784522804927_",
    viewBox: "0 0 1406 1059",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    style: {
      enableBackground: "new 0 0 1406 1059"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#01BFA5;}\n\t.st1{clip-path:url(#SVGID_00000064353986909617184630000014626520092227989437_);fill:#1DE9B6;}\n\t\n\t\t.st2{opacity:0.41;clip-path:url(#SVGID_00000064353986909617184630000014626520092227989437_);fill:none;stroke:#FFFFFF;stroke-width:19;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 1406,
    height: 1059
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 1406,
    height: 1059
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119100052168296639740000001736821853401999494_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      clipPath: "url(#SVGID_00000119100052168296639740000001736821853401999494_)",
      fill: "#1DE9B6"
    },
    cx: 218.3,
    cy: 879.2,
    r: 363.7
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      opacity: 0.41,
      clipPath: "url(#SVGID_00000119100052168296639740000001736821853401999494_)",
      fill: "none",
      stroke: "#FFFFFF",
      strokeWidth: 19,
      strokeMiterlimit: 10
    },
    cx: 1205.1,
    cy: 55.1,
    r: 117.2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegisterPageAbstractShapes);
export default __webpack_public_path__ + "static/media/register_page_abstract_shapes.0a40de68aebaa2036dff2de6a14d147b.svg";
export { ForwardRef as ReactComponent };